import request from '@/utils/request'

let LogisticsApi = {

  /*添加物流中心*/
  editLogistics(data, errorback) {
    return request._post('/shop/plus.logistics.lists/edit', data, errorback);
  },

  /* 物流中心列表 */
  logisticsList(data,errorback){
    return request._post('/shop/plus.logistics.lists/index',data,errorback);
  },
  /* 区域城市 */
  detail(data,errorback){
    return request._get('/shop/plus.logistics.lists/edit',data,errorback);
  },
  /* 删除区域中心 */
  deleteLogistics(data,errorback){
    return request._post('/shop/plus.logistics.lists/delete',data,errorback);
  },
  /* 获取物流中心设置 */
  settingDetail(data,errorback){
    return request._get('/shop/plus.logistics.setting/index',data,errorback);
  },
  editSetting(data,errorback){
    return request._post('/shop/plus.logistics.setting/index',data,errorback);
  },
  accountList(data,errorback){
    return request._post('/shop/plus.logistics.manager/index',data,errorback);
  },
  addAccount(data,errorback){
    return request._post('/shop/plus.logistics.manager/add',data,errorback);
  },
  deleteAccount(data,errorback){
    return request._post('/shop/plus.logistics.manager/delete',data,errorback);
  },
  productList(data,errorback){
    return request._post('/shop/plus.logistics.manager/lists',data,errorback);
  },
  updateLogisticsStock (data,errorback){

    return request._post('/shop/plus.logistics.manager/updateLogisticsStock',data,errorback);
    
  }
}

export default LogisticsApi;



// WEBPACK FOOTER //
// ./src/api/logistics.js